import { useEffect, useState } from "react";
import axios from "axios";
import config from "../config";
import { DEFAULT_LEGAL } from "./legalDefaults";

export const DEFAULT_SITE = {
  hero: {
    eyebrow: "Trusted by Families in Your Neighbourhood",
    headline: "Premium At-Home Vaccination for Your Family",
    headline_accent: "Vaccination",
    subhead: "Certified nurses. Strict hygiene protocols. Long-term digital vaccination records. Book for yourself, your children, and your parents — all from the comfort of home.",
    positioning: "Premium in experience. Sensible in access.",
    images: ["/hero/family-1.jpg", "/hero/family-2.png"],
    video_url: "",
  },
  banner: {
    enabled: true,
    title: "Care that comes to your door",
    body: "Certified nurses, digital records, and concierge support for every jab.",
    image: "/hero/family-1.jpg",
    video_url: "",
    cta_label: "Book a visit",
    cta_url: "/vaccination-catalogue",
  },
  testimonials: {
    heading: "What Our Customers Say",
    items: [
      { quote: "Booked for my parents in Gurgaon — smooth, premium, and genuinely reassuring.", author: "Resident, Sector 56, Gurgaon" },
      { quote: "The nurse arrived on time, the process was hygienic, and the tracking was very helpful.", author: "Resident, Golf Course Road" },
      { quote: "Finally a vaccination experience that feels convenient, professional, and family-friendly.", author: "Executive — The Camellias" },
    ],
  },
    footer: {
    tagline: "Uncompromising Care. Seamlessly Yours.",
    blurb: "Premium at-home vaccination for discerning families. Strict hygiene protocols, digital records, and concierge-level care at your doorstep.",
    founder_quote: "As a professional in Gurgaon, I built BookMyJab because my own family deserved better than crowded hospitals. We treat your family like our own.",
    founder_credit: "— Founder, BookMyJab",
    phone: "+91 9873 55 4343",
    email: "support@bookmyjab.com",
    address_line1: "Golf Course Road & Extension,",
    address_line2: "DLF Phases, Sector 54-57",
    address_city: "Gurgaon, Haryana, India",
    instagram: "https://www.instagram.com/bookmyjab",
    linkedin: "https://linkedin.com/company/bookmyjab",
    twitter: "https://twitter.com/bookmyjab",
    facebook: "https://www.facebook.com/share/1FCaED6NHv/",
    copyright: "© BookMyJab Pvt. Ltd. All rights reserved.",
    pillars: "Qualified Professionals · Clinical Reliability · Intelligent Technology · Trusted Experience",
  },
  navbar: {
    tagline: "Uncompromising Care. Seamlessly Yours.",
    logo: "",
  },
  ticker: {
    enabled: true,
    text: "At-home vaccination across Gurgaon · Certified nurses · Doctor-reviewed care · Book for your family today",
  },
  my_partners: {
    enabled: true,
    eyebrow: "My Partners",
    headline: "Trusted brands and clinical partners",
    items: [],
  },
  serving: {
    enabled: true,
    eyebrow: "Coverage",
    title: "Serving Gurgaon",
    body: "Currently available across Gurgaon — DLF Phases, Golf Course Road, Golf Course Extension, Sector 54-57, and surrounding premium neighbourhoods. Reaching the rest of Delhi NCR soon.",
    areas: "DLF Phases, Golf Course Road, Golf Course Extension, Sector 54-57",
  },
  contact: {
    eyebrow: "Get In Touch",
    headline: "We're Here to Help",
    body: "Have questions about our service? Need help with a booking? Our dedicated healthcare coordinators respond within 15 minutes.",
    whatsapp_label: "WhatsApp Concierge",
    whatsapp_hint: "Response within 15 minutes",
    email: "support@bookmyjab.com",
    phone: "+91 9873 55 4343",
    serving_title: "Serving Gurgaon",
    serving_body: "Currently available across Gurgaon — DLF Phases, Golf Course Road, Golf Course Extension, Sector 54-57, and surrounding premium neighbourhoods. Reaching the rest of Delhi NCR soon.",
    hours_label: "Concierge Hours",
    hours_weekday: "Monday – Saturday: 8 AM – 8 PM",
    hours_sunday: "Sunday: 9 AM – 2 PM",
  },
  partners: {
    eyebrow: "Medical Partners",
    headline: "Doctor-reviewed care, at home.",
    body: "Our medical partners support prescription review, vaccination guidance, and clinical safety protocols before eligible home visits.",
    cta_label: "Book now",
    cta_note: "Have a prescription? Upload it or consult our doctor before booking.",
    doctors: [
      {
        id: "nitin-nandal",
        name: "Dr. (Surg Lt Cdr) Nitin Kumar Nandal",
        credentials: "MBBS | Former Indian Navy Medical Officer | 11 Years Experience",
        role: "Medical Review Partner",
        intro: "Former Indian Navy Medical Officer with 11 years of experience across orthopaedics, surgery, emergency medicine, and trauma care. He has served with reputed institutions including SGT Medical College, Rao Tularam Memorial Hospital, and Artemis Hospital, and was awarded a Commendation in 2021 for exemplary service.",
        image: "/doctors/doctor-nitin-nandal.jpg",
      },
      {
        id: "monica-deswal",
        name: "Dr. Monica Deswal",
        credentials: "MBBS, MD Pediatrics | NICU & PICU Care | 7 Years Experience",
        role: "Pediatric Clinical Partner",
        intro: "Dedicated pediatrician with 7 years of experience in neonatal and pediatric intensive care. She completed MBBS and MD Pediatrics from Pt. BD Sharma PGIMS, Rohtak, and has worked with SGT Medical College, Cloudnine Hospital Gurugram, and Artemis Lite Gurugram.",
        image: "/doctors/doctor-monica-deswal.jpg",
      },
    ],
  },
  why: {
    eyebrow: "Why Choose Us",
    headline: "Why BookMyJab?",
    reasons: [
      { icon: "ShieldCheck", title: "Certified Nurses", desc: "All nurses are qualified, verified, and background-checked professionals." },
      { icon: "Sparkles", title: "Safe & Hygienic", desc: "Strict hygiene protocols and sterile equipment where applicable, at your home." },
      { icon: "Home", title: "Home Convenience", desc: "No travel, no waiting rooms. Premium healthcare at your doorstep." },
      { icon: "Users", title: "Family-First Care", desc: "Book for yourself, kids, parents, and elderly — all in one app." },
      { icon: "MessageCircle", title: "Concierge Support", desc: "Dedicated healthcare coordinators available via WhatsApp within 15 minutes." },
      { icon: "FileText", title: "Digital Vault", desc: "Vaccination certificates and receipts stored permanently in your app." },
    ],
    images: [
      { url: "/why/customers-1.png", caption: "Trusted care for your loved ones at home" },
      { url: "/why/happy-customers.jpg", caption: "Three generations, one trusted healthcare partner" },
      { url: "/why/nurses.png", caption: "Certified, professional, and always ready" },
      { url: "/why/collage.png", caption: "Premium care for every member of your family" },
    ],
  },
  catalogue: {
    eyebrow: "Catalogue",
    headline: "Vaccinations we can arrange at home",
    body: "Explore commonly requested paediatric, adult, elderly and travel vaccinations. Final suitability, prescription requirement, brand availability and payable amount are confirmed before scheduling.",
    cta_label: "View full catalogue",
    categories: [
      { id: "paediatric", title: "Paediatric Vaccines", examples: "BCG · Hepatitis B · Rotavirus · MMR" },
      { id: "adults", title: "Adult Vaccines", examples: "Influenza · Hepatitis A/B · HPV · Tdap" },
      { id: "elderly", title: "Elderly Care Vaccines", examples: "Influenza · Pneumococcal · Shingles · Booster" },
      { id: "travel", title: "Travel & Special Vaccines", examples: "Yellow Fever · Rabies · Typhoid · Meningococcal" },
      { id: "other", title: "Other Nursing Services", examples: "IV/IM Administration · IV Line Placement · Catheterisation" },
    ],
  },
  legal: { ...DEFAULT_LEGAL },
};

function merge(base, extra) {
  if (!extra || typeof extra !== "object") return base;
  if (Array.isArray(base)) return Array.isArray(extra) && extra.length ? extra : base;
  const out = { ...base };
  Object.keys({ ...base, ...extra }).forEach((k) => {
    if (Array.isArray(base[k]) || Array.isArray(extra[k])) {
      if (Array.isArray(extra[k])) out[k] = extra[k];
    } else if (extra[k] && typeof extra[k] === "object" && base[k] && typeof base[k] === "object" && !Array.isArray(base[k])) {
      out[k] = merge(base[k], extra[k]);
    } else if (extra[k] !== undefined && extra[k] !== null && extra[k] !== "") {
      out[k] = extra[k];
    }
  });
  return out;
}

export function brandLogo(site) {
  const custom = mediaUrl(site?.navbar?.logo || site?.footer?.logo || "");
  return custom || config.LOGO_URL;
}

export function mediaUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("/api/")) return `${config.API.replace(/\/api$/, "")}${path}`;
  if (path.startsWith("/")) return path;
  return path;
}

export function useSiteContent() {
  const [site, setSite] = useState(DEFAULT_SITE);
  useEffect(() => {
    axios.get(`${config.API}/cms/site`)
      .then(({ data }) => setSite(merge(DEFAULT_SITE, data.sections || data)))
      .catch(() => {});
  }, []);
  return site;
}
